import { SearchOperationActions } from './../actions/searchOperation';

import { SET_SEARCH_OPERATION } from '../constants';

export interface SearchOperationState {
  searchOperation: string;
}

const initialState: SearchOperationState = {
  searchOperation: '',
};

export const searchOperationReducer = (
  state = initialState,
  action: SearchOperationActions,
): SearchOperationState => {
  switch (action.type) {
    case SET_SEARCH_OPERATION:
      return {
        ...state,
        searchOperation: action.payload,
      };
    default:
      return state;
  }
};
